import { instance } from 'api/core';
import { CallbackObject } from 'api/core/get-page-function';

export const markAsrsServerProduct = async (serverId: string, productId: string, callback: CallbackObject<void>) => {
  try {
    await instance.post(`/catalog/asrs/${serverId}/products/${productId}`);
    callback.success();
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
